module.exports = __webpack_public_path__ + "static/media/CONTRATO PROFECO prepago 223-2020.7b9ee772.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/CONTRATO PROFECO prepago 223-2020.pdf
// module id = 357
// module chunks = 0